import { render, staticRenderFns } from "./EmptyBottom.vue?vue&type=template&id=fe62c10a&scoped=true&"
import script from "./EmptyBottom.vue?vue&type=script&lang=js&"
export * from "./EmptyBottom.vue?vue&type=script&lang=js&"
import style0 from "./EmptyBottom.vue?vue&type=style&index=0&id=fe62c10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe62c10a",
  null
  
)

export default component.exports